// TODO: this might be handled by useFilter
import { ChangeEvent } from 'react'
import { useSearchParams } from 'libs/router'
import { getCurrentQuery } from 'utils/getCurrentQuery'

interface IUseSearch {
	name: string
}

export const useSearch = ({ name }: IUseSearch) => {
	const [, setSearchParams] = useSearchParams()

	const handleSearch = (data: ChangeEvent<HTMLInputElement>) => {
		const query = getCurrentQuery()
		const { value } = data.target
		const newParams = new URLSearchParams(query)

		if (value.length >= 1) {
			newParams.set(name, value)
		} else {
			newParams.delete(name)
		}

		newParams.delete('cursor')
		setSearchParams(newParams)
	}

	return {
		handleSearch
	}
}
